import React from 'react'
import { connect } from 'react-redux'
import { map, max, min, values, keys, toPairs, sortBy, take, takeRight } from 'lodash'
import Dimensions from 'react-dimensions'
import { scaleLinear } from "d3-scale"
import './index.css'
import { Origin } from 'redux-tooltip';
import { setSelectedCountry, setComparisonCountry } from '../../state/actions'
import BubbleAndBarChart from '../BubbleAndBarChart'
import { continentsColors } from '../../utils'

const Ocircle = Origin.wrapBy('circle');

class BubbleOverlay extends React.PureComponent {

  componentDidMount(){
    // const node = ReactDOM.findDOMNode(this)
    // node.scrollIntoView(true)
    window.scrollTo(0, 0)
  }

  render(){
    const { handleSelectCountry, selectedCountry, comparisonCountry, latestDataByIndicator } = this.props
    return (

      <div className="BubbleChart__chart_container" onClick={handleSelectCountry(null)}>
        <div className="BubbleChart__overlay border-blue">
          <div className={`${ comparisonCountry ? 'BubbleChart__overlay__box--double' : 'BubbleChart__overlay__box' }`}
            onClick={(e)=> { e.stopPropagation()}}>
            <BubbleAndBarChart latestDataByIndicator={latestDataByIndicator} countryCode={selectedCountry}/>
          </div>
          {(comparisonCountry !== null) && (
            <div className="BubbleChart__overlay__box--double" onClick={(e)=> { e.stopPropagation()}}>
              <BubbleAndBarChart latestDataByIndicator={latestDataByIndicator} countryCode={comparisonCountry}/>
            </div>
          )}
        </div>
      </div>

    )
  }

}

class BubbleChart extends React.PureComponent {

  getFillOpacity(d, scale){
    const { emptyFill, dataMap } = this.props
    if(dataMap[d.id]){
      const out = scale(dataMap[d.id])
      return out
    }
    return emptyFill ? 1 : 0
  }


  handleSelectCountry = (countryCode) => (e) => {
    this.props.setSelectedCountry(countryCode)
    if(countryCode === null){
        this.props.setComparisonCountry(null)
    }
  }


  render() {
    const { countries, countriesContinents,
      dataMap, borderColor='#0D66A5',
      maxScale, minScale, decreasing=false, containerWidth, itemSize=50, itemMargin=5, labelheight=10,
      latestDataByIndicator, comparisonCountry, selectedCountry,
      colorMode, countryMode } = this.props

    const dataValues = values(dataMap)
    const sortedValues = sortBy(toPairs(dataMap), i => decreasing ? -i[1] : i[1])

    let dataKeys=[];
    if(countryMode === 'top'){
      dataKeys = map(sortedValues.reverse(), i => i[0])
    } else if (countryMode === 'bottom'){
      dataKeys = map(sortedValues, i => i[0])
    } else {
      dataKeys= keys(dataMap).sort()
    }

    let maxValue = maxScale || max(dataValues)
    // let minValue = minScale || min(dataValues)

    const scale = scaleLinear().domain([0, maxValue]).range(decreasing ? [itemSize/2, 0] : [0, itemSize/2])

    const itemWidth = itemSize + ( itemMargin*2 )
    const itemHeight = itemSize + ( itemMargin*2 ) + labelheight
    const itemsPerRow = Math.floor(containerWidth / itemWidth)
    const numRows = Math.ceil(dataKeys.length / itemsPerRow)
    // const plotItems = dataKeys.reduce((accumulator, currentValue, currentIndex) => {
    //   return accumulator}, [])

    let dataRows = []
    for(let i=0;i<numRows; i++){
      let row = []
      for (let j=0; j<itemsPerRow; j++){
        const idx = i * itemsPerRow + j;
        if(idx < dataKeys.length){
          row.push([ dataKeys[idx], dataMap[dataKeys[idx]] ])
        }

      }
      dataRows.push(row)
    }

    const overlayProps = { handleSelectCountry:this.handleSelectCountry,
      selectedCountry, comparisonCountry, latestDataByIndicator }


    const circleFill = (countryCode) => {
      return colorMode === 'continent'
      ? continentsColors[countriesContinents[countryCode]]
      : '#C3DDF1'
    }


    return (
      <div style={{ position:'relative' }}>

        {(selectedCountry !== null) && <BubbleOverlay {...overlayProps}/>}

        <svg className="MapChart__svg"
          style={{borderColor:borderColor}} height={itemHeight*(numRows+1)} width={containerWidth}>
          <g>
            { dataRows.map((row, i) => (
              <g key={i} transform={`translate(0, ${i*itemHeight})`}>
                { row.map((item, j) => (
                  <g key={j} className="BubbleChart__container">
                    <rect onClick={ this.handleSelectCountry(item[0]) } className="BubbleChart__element"
                      y={itemMargin} x={j*itemWidth}
                      width={itemWidth} height={itemWidth+labelheight}></rect>
                    <Ocircle onClick={this.handleSelectCountry(item[0])}
                      content={`${countries[item[0]]}: ${item[1]}`} className="BubbleChart__circle"
                      style={{fill:circleFill(item[0])}}
                      cx={j*itemWidth + itemWidth/2} cy={itemWidth/2 } r={scale(item[1])}/>
                    <text onClick={this.handleSelectCountry(item[0])} className="BubbleChart__label" x={j*itemWidth + itemWidth/2} y={itemWidth + labelheight/2}>{item[0]}</text>
                    <circle onClick={this.handleSelectCountry(item[0])} r={2} cx={j*itemWidth + itemWidth/2} cy={itemWidth/2 }/>
                  </g>
                )
              )}
              </g>

            ))}
          </g>
        </svg>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  countries: state.countries,
  countriesContinents: state.countriesContinents,
  selectedCountry: state.selectedCountry,
  comparisonCountry: state.comparisonCountry,
  colorMode: state.colorMode,
  countryMode: state.countryMode,

})

const mapDispatchToProps = { setSelectedCountry, setComparisonCountry }

export default connect(mapStateToProps, mapDispatchToProps)(Dimensions()(BubbleChart))



// WEBPACK FOOTER //
// ./src/components/BubbleChart/index.js